import { EmailSendModeDto } from '@/api/generated';

export enum EmailBodyContentType {
  HTML = 'HTML',
  TEXT = 'TEXT',
}

enum EmailAttachmentState {
  DELETED = 'DELETED',
  ERROR = 'ERROR',
  EXTERNAL = 'EXTERNAL',
  NEW = 'NEW',
  UPLOADED = 'UPLOADED',
}

enum EmailAttachmentType {
  FILE = 'FILE',
  ITEM = 'ITEM',
  REFERENCE = 'REFERENCE',
}

enum EmailStatus {
  DELETED = 'DELETED',
  VALID = 'VALID',
}

export type AppAttachmentWithoutContent = {
  attachmentId: string;
  contentId: string;
  contentType: string;
  emailId: Value<string>;
  externalAttachmentId: Value<string>;
  fileName: string;
  isInline: boolean;
  size: number;
  state: EmailAttachmentState;
  type: EmailAttachmentType;
};

export type DeltaEmailBasicUpdate = {
  email: {
    attachments: Property<AppAttachmentWithoutContent[]>;
    attachmentsCount: Property<number>;
    bcc: Property<Value<string>[]>;
    body: Property<string>;
    bodyContentType: Property<EmailBodyContentType>;
    bodyPreview: Property<string>;
    cc: Property<Value<string>[]>;
    createdDateTime: Property<string>;
    emailThreadId: Property<Value<string>>;
    externalEmailId: Value<string>;
    from: Property<Value<string>>;
    hasAttachments: Property<boolean>;
    isDraft: Property<boolean>;
    isRead: Property<boolean>;
    lastModifiedDateTime: Property<string>;
    receivedDateTime: Property<string>;
    sendMode: Property<EmailSendModeDto>;
    sentDateTime: Property<string>;
    status: Property<EmailStatus>;
    subject: Property<string>;
    to: Property<Value<string>[]>;
    userFolderId: string;
    webLink: Property<string>;
  };
  show: boolean;
};

type Property<T> = {
  set: boolean;
  value?: T;
};

type Value<T> = { value: T };

export const isDeltaEmailBasicUpdate = (value: unknown): value is DeltaEmailBasicUpdate => {
  if (value === undefined || value === null) {
    return false;
  }
  const partialModel = value as Partial<DeltaEmailBasicUpdate>;
  return Boolean(partialModel?.email?.externalEmailId?.value);
};
